import React, { useState } from 'react';
import './AlertBanner.css';

export default function AlertBanner() {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return (
    <div className="alert-banner" role="alert" aria-live="assertive">
      <div className="alert-banner__icon">⚠️</div>
      <div className="alert-banner__text">
        <strong>ALERTE SÉCURITÉ :</strong> JumpVendor.com est un site frauduleux actif. Des centaines de victimes signalées. Partagez cette page pour protéger vos proches.
      </div>
      <button className="alert-banner__close" onClick={() => setVisible(false)} aria-label="Fermer">✕</button>
    </div>
  );
}
